import { IShopifyCollection } from "@smartrr/shared/utils/bundles";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

import { store } from "../../store";

export const loadBundles = async () => {
  store.dispatch({
    type: "LOADING_BUNDLES",
    payload: undefined,
  });
  store.dispatch({
    type: "LOADING_BUNDLE_COLLECTIONS",
    payload: undefined,
  });
  const bundleConfig = await typedCustomerFrontendApi.getReq("/bundle-config");
  if (bundleConfig.type === "error") {
    store.dispatch({
      type: "ERROR_LOADING_BUNDLES",
      payload: {
        errorMessage: "error loading bundle information",
      },
    });
  }
  if (bundleConfig.type === "success") {
    store.dispatch({
      type: "LOADED_BUNDLES",
      payload: {
        bundles: bundleConfig.body.configs,
      },
    });

    const collections: IShopifyCollection[] = [];

    if (bundleConfig.body.collections) {
      for (const collection of bundleConfig.body.collections) {
        if (collection) {
          collections.push(collection);
        }
      }
    }

    store.dispatch({
      type: "LOADED_BUNDLE_COLLECTIONS",
      payload: {
        collections,
      },
    });
  }
};

export const loadBundleById =
  (bundleId: string): CustomerThunkAction<"LOADING_BUNDLE" | "ERROR_LOADING_BUNDLE" | "LOADED_BUNDLE"> =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/bundle-config/:bundleId", {
        params: { bundleId },
      }),
      () =>
        dispatch({
          type: "LOADING_BUNDLE",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "ERROR_LOADING_BUNDLE",
          payload: {
            errorMessage: "error loading bundle information",
          },
        }),
      bundle =>
        dispatch({
          type: "LOADED_BUNDLE",
          payload: bundle,
        })
    );

export const updateBundleLine =
  (
    bundleLines: { id: number; quantity: number }[],
    bundleParentId: string
  ): CustomerThunkAction<
    "LOADING_UPDATING_BUNDLE_LINES" | "ERROR_UPDATING_BUNDLE_LINES" | "SUCCESS_UPDATING_BUNDLE_LINES"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.putReq("/purchase-state-line/:id/bundleLines", {
        reqBody: { bundleLines },
        params: { id: bundleParentId },
      }),
      () =>
        dispatch({
          type: "LOADING_UPDATING_BUNDLE_LINES",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "ERROR_UPDATING_BUNDLE_LINES",
          payload: {
            errorMessage: "error updating bundleLine",
          },
        }),
      purchaseState =>
        dispatch({
          type: "SUCCESS_UPDATING_BUNDLE_LINES",
          payload: purchaseState,
        })
    );

export const updateBundleCustomAttributes =
  (
    updatedBundleValue: string, // Must be stringified before being sent to Shopify
    purchaseStateId: string,
    bundleParentShopifyId: string
  ): CustomerThunkAction<
    | "LOADING_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES"
    | "ERROR_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES"
    | "SUCCESS_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.putReq("/purchase-state/:id/customAttributes", {
        reqBody: {
          attributes: updatedBundleValue,
          lineItemShopifyIds: [bundleParentShopifyId],
        },
        params: { id: purchaseStateId },
      }),
      () =>
        dispatch({
          type: "LOADING_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "ERROR_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES",
          payload: {
            errorMessage: "error updating bundleLine",
          },
        }),
      purchaseState =>
        dispatch({
          type: "SUCCESS_UPDATING_BUNDLE_CUSTOM_ATTRIBUTES",
          payload: purchaseState,
        })
    );

export const loadCollections =
  (): CustomerThunkAction<"LOAD_COLLECTIONS_LOADING" | "LOAD_COLLECTIONS_ERROR" | "LOAD_COLLECTIONS_SUCCESS"> =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/collections"),
      () =>
        dispatch({
          type: "LOAD_COLLECTIONS_LOADING",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "LOAD_COLLECTIONS_ERROR",
          payload: {
            errorMessage: "error loading all collections",
          },
        }),
      allCollections =>
        dispatch({
          type: "LOAD_COLLECTIONS_SUCCESS",
          payload: allCollections.body.data.collections,
        })
    );

export const getCollectionByHandle =
  (
    collectionHandle: string
  ): CustomerThunkAction<"GET_COLLECTION_LOADING" | "GET_COLLECTION_ERROR" | "GET_COLLECTION_SUCCESS"> =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/collections/:handle", {
        params: { handle: collectionHandle },
      }),
      () =>
        dispatch({
          type: "GET_COLLECTION_LOADING",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "GET_COLLECTION_ERROR",
          payload: {
            errorMessage: "error loading collection by handle",
          },
        }),
      collectionData =>
        dispatch({
          type: "GET_COLLECTION_SUCCESS",
          payload: collectionData.body.data.collectionByHandle,
        })
    );
